export const DownloadType = {
  PRODUKT: 'PRODUKT',
  PAKET: 'PAKET',
} as const;

export type DownloadType = (typeof DownloadType)[keyof typeof DownloadType];
